<div class="PIC" :class="classes">

    <input
        type="text"
        class="PIC__input"
        v-for="(x, i) in charArray"
        v-model="pin[i]"
        :key="i"
        :ref="'input' + i"
        :placeholder="placeholder"
        :disabled="disabled || readonly"
        :maxlength="maxlength"
        @input="onInput(i)"
        @keydown="onKeyDown($event, i)"
        @focus="selectTarget"
        @paste.prevent="onPaste($event, i)"/>

</div>